exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\r\n    width: 100%\r\n}\r\n\r\n.balloon1 {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin: 1.5em 0;\r\n    padding: 7px 10px;\r\n    min-width: 120px;\r\n    max-width: 100%;\r\n    color: #555;\r\n    font-size: 16px;\r\n    background: #e0edff;\r\n}\r\n\r\n.balloon1:before{\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 50%;\r\n    margin-left: -15px;\r\n    border: 15px solid transparent;\r\n    border-top: 15px solid #e0edff;\r\n}\r\n\r\n.balloon1 p {\r\n    margin: 0;\r\n    padding: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/yarukami/src/app/top/totalk/totalk.component.css
// module id = ../../../../../src/app/top/totalk/totalk.component.css
// module chunks = main